import cx from 'classnames';
import { format } from "date-fns";
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Clock, Copy, Edit2, Info, MessageSquare, RefreshCcw, Save, Trash2 } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AuthenticateChildren from '../../AuthenticateChildren';
import { AddButton } from '../../components/AddButton';
import { Credits } from '../../components/Credits';
import { FeatherButton } from '../../components/FeatherButton';
import { Loader } from '../../components/Loader';
import { PTInputText } from '../../components/PTElements';
import { notificationChore_Status, roles, scheduleTypes } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/notificationchores";
import { urls } from '../../urls';
import './NotificationChores.css';
import { StatusObj } from './TransactionalChores';

const NC = props => {
    useEffect(() => {
        props.fetchnotificationchores(props);
    }, []);

    const deleteNc = nc => {
        props.deleteItem(nc.id).then(() => {
            EVO.success('Deleted!');
            props.history.go();
        });
    }

    const refreshNC = nc => {
        props.retryNC(nc).then(() => {
            EVO.success('Updated');
            props.history.go();
        });
    }

    const status = nc => {
        return <span data-status={nc.status}
            className={cx("nc-status", { red: nc.status === notificationChore_Status.Paused || nc.status === notificationChore_Status.Draft || nc.status === notificationChore_Status.InsufficientCredits })}>
            {EVO.getPropertyNameFromValue(notificationChore_Status, nc.status).replace(/([A-Z])/g, " $1")}
        </span>
    }

    const renderTable = (chores, filter) => {
        return !EVO.any(chores) ? null : <div className="nc-table-wrapper">
            <div className="nc-title">{filter.label} SMS</div>
            <table className='table table-striped nc-table'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th className="thin">Status</th>
                        <th className="thin">Test</th>
                        <th className="thin">Details</th>
                        <th className="thin">Edit</th>
                        <th className="thin">Duplicate</th>
                        <AuthenticateChildren roles={[roles.Admin]} ignoreViewAs><th className="thin">Version</th></AuthenticateChildren>
                        <th className="thin">Delete</th>
                        {filter.value === scheduleTypes.OneOff.value && <th>Sent Date</th>}
                        <th className="thin">Sent</th>
                    </tr>
                </thead>
                <tbody>
                    {chores.map(notificationchore =>
                        <tr key={notificationchore.id}>
                            <td><EditName chore={notificationchore} /></td>
                            <td><StatusObj chore={notificationchore} /></td>
                            <td><SendTestEmail chore={notificationchore} /></td>
                            <td><FeatherButton feather={<Info />} to={`/sms/${notificationchore.id}/history`}></FeatherButton></td>
                            <td>{(notificationchore.scheduleTypeId === scheduleTypes.Recurring ||
                                (notificationchore.status !== notificationChore_Status.Sent && notificationchore.status !== notificationChore_Status.InProgress && notificationchore.status !== notificationChore_Status.Queued)) &&
                                <FeatherButton feather={<Edit2 size={18} />} to={`/sms/${notificationchore.id}`}></FeatherButton>}</td>
                            <td><FeatherButton feather={<Copy />} to={`/sms/${notificationchore.id}/copy`}></FeatherButton></td>
                            <AuthenticateChildren roles={[roles.Admin]} ignoreViewAs><td><FeatherButton feather={notificationchore.versionCount || 0} to={`/sms/${notificationchore.id}/version`}></FeatherButton></td></AuthenticateChildren>
                            <td>
                                {(notificationchore.scheduleTypeId === scheduleTypes.Recurring ||
                                    (notificationchore.status !== notificationChore_Status.Sent && notificationchore.status !== notificationChore_Status.InProgress && notificationchore.status !== notificationChore_Status.Queued)) &&
                                    <FeatherButton feather={<Trash2 />} onClick={() => deleteNc(notificationchore)} />}
                            </td>
                            {filter.value === scheduleTypes.OneOff.value && <td>{notificationchore.sentDateTime && format(new Date(notificationchore.sentDateTime), 'dd/MM/yyyy HH:mm')}</td>}
                            <td>{notificationchore.totalSent}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    const renderInsufficient = (chores) => {
        return !EVO.any(chores) ? null : <div className="nc-table-wrapper">
            <div className="nc-title">Requires Attention</div>
            <table className='table table-striped nc-table'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th className="thin">Status</th>
                        <th className="thin">Details</th>
                        <th className="thin">Edit</th>
                        <th className="thin">Duplicate</th>
                        <th className="thin">Delete</th>
                        <th className="thin">Approx credit required</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {chores.map(nc =>
                        <tr key={nc.id}>
                            <td>{nc.name}</td>
                            <td>{status(nc)}</td>
                            <td><FeatherButton feather={<Info />} to={`/sms/${nc.id}/history`}></FeatherButton></td>
                            <td><FeatherButton feather={<Edit2 size={18} />} to={`/sms/${nc.id}`}></FeatherButton></td>
                            <td><FeatherButton feather={<Copy />} to={`/sms/${nc.id}/copy`}></FeatherButton></td>
                            <td>
                                <FeatherButton feather={<Trash2 />} onClick={() => deleteNc(nc)} />
                            </td>
                            <td>{nc.approxCreditsToComplete}</td>
                            <td>{nc.approxCreditsToComplete < props.smsCredit ? <FeatherButton feather={<RefreshCcw />} onClick={() => refreshNC(nc)} /> : null}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    return (
        <div>
            <Loader loading={props.loading && !props.notificationchores}>
                {!props.error && <div>
                    <Credits smsCredit={props.smsCredit} />
                    {props.attentionchores && renderInsufficient(props.attentionchores)}
                    {renderTable(props.recurringchores, scheduleTypes.Recurring)}
                    {renderTable(props.oneoffchores, scheduleTypes.OneOff)}
                    <AddButton to={`/sms/new`} />
                    </div>
                }
            </Loader>
        </div>
    );
}

const SendTestEmail = ({ chore }) => {
    const [sendingEmail, setSendingEmail] = useState(false);

    const sendEmail = () => {
        if (sendingEmail)
            return;

        setSendingEmail(true);
        EVO.post('/api/notificationchores/test', { id: chore.id }).then(r => {
            let message = 'Test sent';
            if (r.email) {
                message += ' to ' + r.email;
            }
            EVO.success(message);
            setSendingEmail(false);
        }).catch(e => {
            setSendingEmail(false);
        });
    };

    return <FeatherButton onClick={sendEmail} feather={sendingEmail ? <Clock /> : <MessageSquare />} />
}

const EditName = ({ chore }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState(chore.name);

    const edit = () => {
        setShow(true);
    };

    const updateName = (values) => {
        setLoading(true);
        EVO.fetch(urls.api.notificationchores.updateName, { id: values.id, name: values.name }).then(r => {
            EVO.success('Successfully updated name');
            setShow(false);
            setLoading(false);
            setName(values.name);
        }).catch(e => {
            EVO.alert('Error updating name');
            setLoading(false);
        });
    };

    const initVal = {
        name: name,
        id: chore.id
    };

    return !show ? <span>{name}<FeatherButton feather={<Edit2 size={18} />} onClick={edit} classNames={'nc-title-edit-btn'} /></span> : <Formik
        initialValues={initVal}
        onSubmit={updateName}>
        {({ submitForm }) =>
            <Form>
                <div className="nc-title-edit">
                    <Field name="name" type="text" component={PTInputText} inline='true' left='true' autoFocus disabled={loading} />
                    <Loader loading={loading}><FeatherButton feather={<Save />} type="submit" /></Loader>
                </div>
            </Form>
        }
    </Formik>
};

const mapStateToProps = ({ notificationchores }) => ({
    notificationchores: notificationchores.notificationchores,
    loading: notificationchores.loading,
    smsCredit: notificationchores.smsCredit,
    error: notificationchores.error,
    activeLoading: notificationchores.activeLoading,
    deleteLoading: notificationchores.deleteLoading,
    oneoffchores: notificationchores.oneoffchores,
    recurringchores: notificationchores.recurringchores,
    attentionchores: notificationchores.attentionchores,
});

export default connect(mapStateToProps, actions)(withRouter(NC));


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NotificationChores.js